// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__d8ffV","container":"styles_container__R9qvI","laurels":"styles_laurels__IX5tY","salesPitch":"styles_salesPitch__2_LOK"};